/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SuspenseBoundary/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SuspenseBoundary({
  children,
  viewPath = "/DesignSystem/SuspenseBoundary"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="SuspenseBoundary.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z164BvB': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical}`}
/>
{children}
</React.Fragment>)
}